'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'messages-question';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e1e7';
var svgPathData = 'M72 16l240 0c13.3 0 24 10.7 24 24l0 192c0 13.3-10.7 24-24 24l-90.4 0c-14.1 0-27.8 4.7-39 13.3l-54.6 42 0-31.3c0-13.3-10.7-24-24-24l-32 0c-13.3 0-24-10.7-24-24L48 40c0-13.3 10.7-24 24-24zM0 40L0 232c0 39.8 32.2 72 72 72l8 0 0 56c0 9.1 5.2 17.5 13.4 21.5s18 3.1 25.2-2.5l93.2-71.7c2.8-2.2 6.2-3.3 9.8-3.3l90.4 0c39.8 0 72-32.2 72-72l0-192c0-39.8-32.2-72-72-72L72-32C32.2-32 0 .2 0 40zM240 392l0-40-7.5 0-40.5 31.1 0 8.9c0 39.8 32.2 72 72 72l90.4 0c3.5 0 7 1.2 9.8 3.3L457.4 539c7.2 5.6 17 6.5 25.2 2.5S496 529.1 496 520l0-56 8 0c39.8 0 72-32.2 72-72l0-192c0-39.8-32.2-72-72-72l-72 0 0 48 72 0c13.3 0 24 10.7 24 24l0 192c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24 10.7-24 24l0 31.3-54.6-42c-11.2-8.6-24.9-13.3-39-13.3L264 416c-13.3 0-24-10.7-24-24zM192 76c14.4 0 26.1 11.7 26.1 26.1 0 9.2-3.9 14.4-9.1 18.3-5.9 4.4-13.4 6.7-17.6 7.6-10.6 2.3-19.4 11.7-19.4 24 0 11 9 20 20 20 5.9 0 11.3-2.6 14.9-6.7 7.2-2.2 16.9-6 26-12.8 13.3-9.9 25.2-26.2 25.2-50.4 0-36.5-29.6-66.1-66.1-66.1-29.2 0-54 18.9-62.7 45.2-3.5 10.5 2.2 21.8 12.6 25.3s21.8-2.2 25.3-12.6C170.7 83.4 180.5 76 192 76zm24 132a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMessagesQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;